import BaseService from "./base.service";
import { Singleton } from "util";
import { ApiResourceBuilder } from "core/builder";

@Singleton
class PlanService extends BaseService {
  async fetch(companyUuid, { filters, order, pagination }) {
    const url = `/billing/v1/plans`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, {
      filters,
      order,
      pagination
    });
    return await this.get(resourceRoute);
  }

  async subscribePlan(params) {
    const url = `/billing/v1/subscriptions`;
    return await this.post(url, params);
  }

  async changePlan(planUuid) {
    const url = `/billing/v1/subscriptions/change_plan`;
    return await this.post(url, { plan_uuid: planUuid });
  }

  async changePaymentMethod(params) {
    const url = `/billing/v1/subscriptions/change_payment`;
    return await this.post(url, params);
  }
}

export default PlanService;



// WEBPACK FOOTER //
// ./src/core/service/plan.service.js